(ns teamoesterreich.user-mode.modal.job-selection-modal
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.arrow-back-ios :refer [arrow-back-ios]]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.done :refer [done]]

            [reagent.core :as r]
            [teamoesterreich.user-mode.profile.lists :as lists]
            [teamoesterreich.util.helper :as h]))


(defn filter-jobs [jobs group education]
  (filter (fn [j]
            (let [group (int group)
                  education (int education)
                  groups (:groups j)
                  groupIds (map :group groups)
                  educationsIds (reduce (fn [c g]
                                          (concat c (:educations g))
                                          ) [] groups)]

              ;(log/out "filter-jobs " (clj->js groupIds) " group IN " group "==" (some #{group} groupIds) " ### " (clj->js educationsIds) " group IN " education "==" (some #{education} educationsIds))
              (and (or (nil? group) (= 0 group) (some #{group} groupIds))
                   (or (nil? education) (= 0 education) (some #{education} educationsIds))
                   )))
          jobs))



(defn get-modal [!st !show-job-modal job_details on-ok-fn]
  (let [!group (r/cursor !st [:group])
        !education (r/cursor !st [:education])
        !job (r/cursor !st [:job])


        jobs-list (filter-jobs (:jobs job_details) @!group @!education)
        education-list (:educations job_details)
        group-list (:groups job_details)
        ]
    [mui/modal
     {
      :aria-labelledby  "simple-modal-title"
      :aria-describedby "simple-modal-description"
      :style            {:display        "flex"
                         :marginRight    "auto"
                         :marginLeft     "auto"
                         :alignItems     "center"
                         :justifyContent "center"}
      :open             (if @!show-job-modal true false)

      }
     [:div
      {
       :class "modal"
       :style {:minWidth 400 :maxWidth 800 :padding "15px"}}

      [mui/grid {:container true}

       [mui/grid {:container false
                  :item      true
                  :xs        12
                  :style     {:padding "15px"}}
        [mui/input-label
         "Berufsgruppe "
         [mui/select
          {:fullWidth true
           :value     (or @!group "")
           :onChange  (fn [e] (reset! !group (h/event-value e)))
           :label     "Berufsgruppe"}
          [mui/menu-item {:value ""} " - "]
          (for [{:keys [id label]} group-list]
            ^{:key (str "group-option" id)} [mui/menu-item {:value (str id)} label])
          ]]

        ]

       [mui/grid {:container false
                  :item      true
                  :xs        12
                  :style     {:padding "15px"}}
        [mui/input-label
         "Berufsweg "
         [mui/select
          {:fullWidth true
           :value     (or @!education "")
           :onChange  (fn [e] (reset! !education (h/event-value e)))
           :label     "Berufsweg"}
          [mui/menu-item {:value ""} " - "]
          (for [{:keys [id label]} education-list]
            ^{:key (str "education-option" id)} [mui/menu-item {:value (str id)} label])
          ]]

        ]
       [mui/grid {:container false
                  :item      true
                  :xs        12
                  :style     {:padding "15px"}}
        [mui/input-label
         "Beruf "
         [mui/select
          {:fullWidth true
           :value     (or @!job "")
           :onChange  (fn [e] (reset! !job (h/event-value e)))
           :label     "Beruf"}
          [mui/menu-item {:value ""} " - "]
          (for [{:keys [id label]} jobs-list]
            ^{:key (str "job-option" id)} [mui/menu-item {:value (str id)} (str label)])
          ]]

        ]



       [mui/grid {:container false
                  :item      true
                  :xs        6}

        [mui/button
         {:style     {:float "left"}
          :variant   "contained"
          :startIcon (r/as-element [arrow-back-ios])
          :onClick   (fn []
                       (on-ok-fn)
                       (reset! !show-job-modal nil))
          }
         "Abbrechen"]

        ]
       [mui/grid {:container false
                  :item      true
                  :xs        6}

        [mui/button
         {:style     {:float "right"}
          :variant   "contained"
          :color     "primary"
          :disabled  (not @!job)
          :startIcon (r/as-element [done])
          :onClick   (fn []
                       (on-ok-fn @!job)
                       (reset! !show-job-modal nil))
          }
         "Speichern"]
        ]
       ]]]
    )
  )


(defn modal [!show-job-modal on-ok-fn]
  (let [job_details (lists/get-job_details)
        !st (r/atom {})]
    (when !show-job-modal
      [get-modal !st !show-job-modal job_details on-ok-fn]
      )))